"use client"

import clsx from "clsx"
import React, { forwardRef, Children } from "react"

import styles from "@/ui/components/DistributedColumnFlexLayout/distributed-column.module.scss"

export type DistributedColumnFlexLayoutProps =
  React.ComponentPropsWithoutRef<"ul"> & {
    numOfColsMd?: 2 | 3
    numOfColsLg?: 3 | 4 | 5
  }

const DistributedColumnFLexLayout = forwardRef<
  HTMLUListElement,
  DistributedColumnFlexLayoutProps
>((props, ref) => {
  const {
    numOfColsMd,
    numOfColsLg,
    children,
    className,
    style,
    ...restOfHtmlAttrs
  } = props

  const childrenArray = Children.toArray(children)

  if (childrenArray.length === 0) {
    return null
  }

  // construct a new style element max number of rows
  const stylesWithVar: React.CSSProperties & {
    "--lg-dist-flex-cols": number
    "--md-dist-flex-cols": number
  } = {
    ...style,
    "--md-dist-flex-cols": numOfColsMd,
    "--lg-dist-flex-cols": numOfColsLg,
  }

  return (
    <ul
      className={clsx(styles.distributedColumnWrapper, className)}
      {...restOfHtmlAttrs}
      style={stylesWithVar}
      ref={ref}
    >
      {childrenArray.map((child, index) => (
        // TODO: explore other solutions to creating keys
        // eslint-disable-next-line react/no-array-index-key
        <li key={index}>{child}</li>
      ))}
    </ul>
  )
})

DistributedColumnFLexLayout.displayName = "DistributedColumnFLexLayout"
export default DistributedColumnFLexLayout
